import { useEffect } from "react";
import "@scss/pages/question-answer.scss";

import { FeedbackChat } from "@feature/feedback-chat";
import { useGetIdFeedbackQuery } from "@lib/feedback";
import { useParams } from "react-router-dom";
import { setTitle } from "@store/title-store";

const FeedbackItem: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: feedbackItem } = useGetIdFeedbackQuery(id!);

  useEffect(() => {
    setTitle([
      { title: "Главная", href: "/" },
      { title: "Техподдержка", href: "/feedback" },
      { title: feedbackItem?.title!, href: `/feedback/${feedbackItem?._id}` },
    ]);
  }, [feedbackItem]);

  return (
    <>
      <main className="content-container">
        <div className="content-section">
          <FeedbackChat feedbackItem={feedbackItem} />
        </div>
      </main>
    </>
  );
};

export default FeedbackItem;
